import designTokens from "./design-tokens/design-tokens";
export * from "./design-tokens/design-tokens.types";
export { getRemTokens } from "./utils/getRemTokens/getRemTokens";
export default designTokens;